import axios from "../../services/request";

export const KEEP_WHEELS_PATH = "/api/v2/downgrade/keep-wheels/";
export const DOWNGRADE_OVER_LIMIT_CODE = "downgrade_over_limit";
export const WHEEL_ARCHIVED_CODE = "wheel_archived";

export const getKeepWheels = (params = {}) =>
  axios.get(KEEP_WHEELS_PATH, { params });

export const saveKeepWheels = (body) => axios.post(KEEP_WHEELS_PATH, body);
